import type { FlowMetricMode } from 'utils/shared/trades/presets';

type AggregateFlowShare = {
  sentimentScore: number;
  netPremiumShare: number;
};

export type AggregateFlowShareSentiment = 'Bullish' | 'Bearish' | '';

export const TOTAL_FLOW_MIXED_THRESHOLD = 10;

export const getAggregateFlowSharePresentation = (
  ticker: AggregateFlowShare,
  metricMode: FlowMetricMode,
) => {
  const isNetMode = metricMode === 'net';
  const value = isNetMode ? ticker.netPremiumShare : ticker.sentimentScore;
  const mixedThreshold = isNetMode ? 0 : TOTAL_FLOW_MIXED_THRESHOLD;
  const sentiment: AggregateFlowShareSentiment =
    value > mixedThreshold ? 'Bullish' : value < -mixedThreshold ? 'Bearish' : '';
  const tooltip = isNetMode
    ? 'Bullish premium minus bearish premium, divided by directional premium'
    : 'Bullish premium minus bearish premium, divided by all premium; midpoint flow is neutral';

  return { value, sentiment, tooltip };
};
